"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Button = _interopRequireDefault(require("../Button"));

var AccountRemovalConfirmation = function AccountRemovalConfirmation(_ref) {
  var isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      isLoading = _ref.isLoading,
      emailAddress = _ref.emailAddress,
      onRemove = _ref.onRemove,
      onCancel = _ref.onCancel;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: isOpen,
    onClose: toggle,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-3xl mb-3 text-dark font-bold break-words"
  }, t('retrofit.removal.header', {
    email: emailAddress
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-12 text-light text-sm"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "mb-4"
  }, t('retrofit.removal.description')), /*#__PURE__*/_react["default"].createElement("p", null, t('retrofit.removal.description.1'))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    disabled: isLoading,
    onClick: onCancel,
    className: "w-32 inline-block mr-5"
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "warning",
    disabled: isLoading,
    onClick: onRemove,
    className: "w-32 inline-block"
  }, t('button.remove')))));
};

var _default = AccountRemovalConfirmation;
exports["default"] = _default;
//# sourceMappingURL=AccountRemovalConfirmation.js.map